import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "m8 14.875 1.123 1.123 2.887-2.888 2.867 2.888L16 14.875l-2.887-2.887L16 9.12l-1.123-1.122-2.867 2.887-2.887-2.887L8 9.12l2.887 2.868z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M9.005 20.638A3.98 3.98 0 0 0 12 22.002v-.005c1.145 0 2.24-.494 2.995-1.364.245-.28.62-.435.99-.41a4 4 0 0 0 3.085-1.155 3.96 3.96 0 0 0 1.155-3.086c-.025-.37.13-.75.41-.99a3.966 3.966 0 0 0 0-5.99 1.22 1.22 0 0 1-.41-.99 4 4 0 0 0-1.155-3.085 3.96 3.96 0 0 0-3.085-1.154c-.37.024-.75-.13-.99-.41a3.966 3.966 0 0 0-5.99 0c-.245.28-.625.43-.99.41A3.99 3.99 0 0 0 4.93 4.928a3.96 3.96 0 0 0-1.155 3.084c.025.37-.13.75-.41.99a3.976 3.976 0 0 0 0 5.996c.28.245.435.625.41.99a3.975 3.975 0 0 0 4.24 4.24c.37-.02.75.13.99.41m1.505-1.315a3.2 3.2 0 0 0-2.415-1.1H8.09c-.07 0-.145.005-.215.01-.58.04-1.125-.16-1.535-.57a2 2 0 0 1-.57-1.535 3.22 3.22 0 0 0-1.09-2.636c-.43-.375-.68-.92-.68-1.49s.25-1.115.68-1.49a3.22 3.22 0 0 0 1.09-2.634 1.965 1.965 0 0 1 2.105-2.105c.99.07 1.98-.34 2.635-1.09.38-.43.92-.68 1.49-.68s1.115.25 1.49.68a3.23 3.23 0 0 0 2.635 1.09c.58-.04 1.125.16 1.535.57.4.404.61.965.57 1.535a3.22 3.22 0 0 0 1.09 2.634c.43.38.68.92.68 1.49s-.25 1.115-.68 1.49a3.22 3.22 0 0 0-1.09 2.636 1.965 1.965 0 0 1-2.105 2.105 3.22 3.22 0 0 0-2.635 1.09c-.385.44-.91.68-1.49.68s-1.11-.24-1.49-.68",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }